import { Invoice } from './../models/invoice';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { User } from 'firebase';
import { Company } from '../models/companies';
import { CompaniesService } from './companies.service';
import { UsersService } from './users.service';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map, take } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root',
})
export class UtilitiesService {

  invoiceCollection: AngularFirestoreCollection<Invoice>;
  invoiceDoc: AngularFirestoreDocument<Invoice>;


    // Http Headers
    httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Basic ' + environment.tokenFacturama,
        'isDevelopment': 'false'
      })
    };

  constructor(
    private router: Router,
    private usersService: UsersService,
    private companiesService: CompaniesService,
    private httpClient: HttpClient,
    private afs: AngularFirestore
  ) { 
   this.invoiceCollection = this.afs.collection('invoices');
  }

  uploadFilesDetail(data): Observable<any> {
    return this.httpClient.post<any>(environment.urlApi + 'uploadFilesDetail/', data)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  
  executeDispersion(dispersionId): Observable<any> {
    return this.httpClient.post<any>(environment.urlApi + 'executeDispersion/', JSON.stringify({'dispersionId':dispersionId}), this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  createInvoice(invoice){
    return this.httpClient.post<any>(environment.urlCreaFactura,JSON.stringify(invoice),this.httpOptions);
  }

  downloadPdfInvoice(idInvoice): Observable<any>{
    return this.httpClient.get<any>(environment.urlConsultarFacturaPDf+'/'+idInvoice,this.httpOptions).pipe(retry(1), catchError(this.errorHandl));
  }

  downloadXmlInvoice(idInvoice): Observable<any>{
    return this.httpClient.get<any>(environment.urlConsultarFacturaXml+'/'+idInvoice,this.httpOptions).pipe(retry(1), catchError(this.errorHandl));
  }

  sendEmailInvoice(idInvoice,email){
    return this.httpClient.post<any>(environment.urlEnviarFactura+idInvoice+"&email=cchavarriatableros@gmail.com",this.httpOptions).pipe(retry(1), catchError(this.errorHandl));
  }
  decryptCard(_cardNumber:string){
    return this.httpClient.post<any>(environment.urlApi + 'card/decrypt', {cardNumber: _cardNumber},this.httpOptions);
  }

  getInvoices(): Observable<Invoice[]>{
    return this.invoiceCollection.valueChanges({ idField: 'id'})
  }

  setInvoiceApi(invoice){
    return this.httpClient.post<any>(environment.urlApi,invoice,this.httpOptions).pipe(retry(1), catchError(this.errorHandl));
  }

  setInvoice(invoice: Invoice): Promise<{ invoice: Invoice } | any> {
    return new Promise(async (resolve, reject) => {
      try {
        const savingNewInvoice = await this.invoiceCollection.add(
          JSON.parse(JSON.stringify(invoice))
        );
        resolve(savingNewInvoice.id);
        const myObj: any = {};
        myObj.id = savingNewInvoice.id;
      } catch (err) {
        reject(err);
      }
    });
  }

  getInvoicesCompany(companyId: string): Observable<Invoice[]> {
    const invoices = this.afs.collection<Invoice>('invoices', (ref) =>
      ref.where('companyId', '==', companyId)
    );
    return invoices.valueChanges();
  }
  
  // Error handling
  errorHandl(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

  dateToNumber(date: Date): number {
    switch(typeof(date)) {
      case 'string': date = new Date(date); break;
      case 'number': return date;
    }
    const dateNumber = `${date.getFullYear()}${this.pad(
      date.getMonth() + 1
    )}${this.pad(date.getDate())}`;
    return Number(dateNumber);
  }

  numberToDate(
    dateNumber: number
  ): { year: number; month: number; day: number; date: Date } {
    const tempDateNumber = '' + dateNumber;
    return {
      year: Number(tempDateNumber.slice(0, 4)),
      month: Number(tempDateNumber.slice(4, 6)),
      day: Number(tempDateNumber.slice(6)),
      date: new Date(
        `${Number(tempDateNumber.slice(0, 4))}/${Number(
          tempDateNumber.slice(4, 6)
        )}/${Number(tempDateNumber.slice(6))}`
      ),
    };
  }

  pad(n: number): string {
    return n >= 10 ? '' + n : '0' + n;
  }

  notifyMe(notificationMessage: string, notificationType: string | 'success') {
    notify({
      message: notificationMessage,
      type: notificationType,
      displayTime: 2000,
      position: 'bottom right',
      height: '55px',
      shading: false,
      closeOnOutsideClick: true,
      width: '120px',
      maxWidth: '120px',
    });
  }
  notifyMeAndRedirect(notificationMessage: string, notificationType: string | 'success', redirectUrl: string) {
    notify({
      message: notificationMessage,
      type: notificationType,
      displayTime: 2000,
      position: 'bottom right',
      height: '55px',
      shading: false,
      closeOnOutsideClick: true,
      width: '120px',
      maxWidth: '120px',
      onShown: this.router.navigate([redirectUrl])
    });
  }

  async getAndStoreData(uid: string): Promise<{ user: any; company: Company } | null> {
    try {
      const myUser = await this.usersService.getUserAsPromise(uid);
      // console.log(uid);
      const udata: any = {};
      udata.active = myUser.active;
      udata.belongsToProgram = myUser.belongsToProgram;
      udata.lastName = myUser.lastName;
      udata.middleName = myUser.middleName;
      udata.phone = myUser.phone;
      udata.companyId = myUser.companyId;
      udata.email = myUser.email;
      udata.id = myUser.id;
      udata.belongsToIhunterProgram = myUser.belongsToIhunterProgram;
      udata.secondLastName = myUser.secondLastName;
      udata.name = myUser.name;
      udata.level = myUser.level;
      udata.companyList = myUser.companyList;

      // console.log(myUser);
      localStorage.setItem('udta', JSON.stringify(udata));
      console.log('ppppp',localStorage);
      //get Company data from DB
      const myClient = await this.companiesService.getCompanyAsPromise(myUser.companyId);
      // console.log(myClient);
      const cdta: any = {};
      cdta.id = myClient.id;
      cdta.programs = myClient.programs;
      cdta.companyLegalName = myClient.companyLegalName;
      cdta.companyName = myClient.companyName;
      localStorage.setItem('cdta', JSON.stringify(cdta));
      return { user: myUser, company: myClient };
    } catch (err) {
      console.log(err);
      return null;
    }
  }

  getUserData() {
    const userData = JSON.parse(localStorage.getItem('udta'));
    return userData;
  }

  getCompanyData() {
    const companyData = JSON.parse(localStorage.getItem('cdta'));
    return companyData;
  }

  getJsonFromCsvFile(file: File) {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = () => {
      let text = reader.result;
      console.log(text);
      this.getJsonFromCsvText(text);
    };
  }
  getJsonFromCsvText(csvText: any) {
    let lines = csvText.split("\n");
    let result = [];
    let headers = lines[0].split(",");
    console.log(headers);
    for (var i = 1; i < lines.length - 1; i++) {
      var obj = {};
      var currentline = lines[i].split(",");
      for (var j = 0; j < headers.length; j++) {
        obj[headers[j]] = currentline[j];
      }
      result.push(obj);
    }
    console.log(result); //JSON
    return result; //JavaScript object
  }
  getGenderOptions() {
    return [
      { name: 'Masculino', val: 'M' },
      { name: 'Femenino', val: 'F' },
    ]
  }

  downloadFile(route: string, filename: string = null): void{
    const baseUrl = '';
    const token = '';

    this.httpClient.get(route, { responseType: 'blob' as 'json' }).subscribe((response: any) =>{
      let dataType = response.type;
      let binaryData = [];
      binaryData.push(response);
      let downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
      if (filename)
          downloadLink.setAttribute('download', filename);
      document.body.appendChild(downloadLink);
      downloadLink.click();
    });
  }
}
